/* Centralised icon mapping for typed domain entities.
 *
 * Each entity exposes a small object so callers can do:
 *   const Icon = DEBT_ICONS[kind] || DEBT_ICONS.default;
 *   <Icon className="h-5 w-5" />
 *
 * Keeping the mapping in one place makes it trivial to change the visual
 * vocabulary later (e.g. swap CreditCard for a different lucide glyph) and
 * guarantees Movimientos, Pagos, Deudas, Inversiones, Metas and Cuentas
 * stay visually coherent.
 */
import {
  Banknote,
  Bitcoin,
  Briefcase,
  Car,
  Coins,
  CreditCard,
  Gift,
  GraduationCap,
  HandCoins,
  Home,
  Landmark,
  PieChart,
  PiggyBank,
  Plane,
  RotateCw,
  ShoppingBag,
  Sparkles,
  Star,
  Target,
  TrendingUp,
  User,
  Wallet,
} from "lucide-react";

// Debts (matches Pydantic DebtIn.kind enum).
export const DEBT_ICONS = {
  credit_card: CreditCard,
  personal_loan: HandCoins,
  mortgage: Home,
  auto_loan: Car,
  revolving_credit: RotateCw,
  other: Coins,
  default: Coins,
};

// Investments (matches InvestmentIn.kind enum).
export const INVESTMENT_ICONS = {
  stocks: TrendingUp,
  crypto: Bitcoin,
  bonds: Landmark,
  etf: PieChart,
  fund: Briefcase,
  dividend: Coins,
  other: Sparkles,
  default: Sparkles,
};

// Goals (already in use locally — re-exported here for consistency).
export const GOAL_ICONS = {
  travel: Plane,
  study: GraduationCap,
  gift: Gift,
  emergency_fund: PiggyBank,
  purchase: ShoppingBag,
  other: Target,
  default: Star,
};

// Cash accounts (matches CashAccountIn.type — bank/cash/wallet).
export const ACCOUNT_ICONS = {
  bank: Landmark,
  cash: Banknote,
  wallet: Wallet,
  default: Wallet,
};

// Payment categories (matches PaymentIn.type — work/personal/debt/recurring).
export const PAYMENT_ICONS = {
  work: Briefcase,
  personal: User,
  debt: CreditCard,
  recurring: RotateCw,
  default: Wallet,
};

/** Tiny helper so call sites don't have to remember the `default` fallback. */
export const pickIcon = (mapping, key) => mapping[key] || mapping.default;
